/**
 * @props templatesForDownload is an array of object consisting template name and a callback function 
 *        example templatesForDownload={[
						{
							templateText: ".xls",
							downloadTemplateCb: () => {},
						},
						{   
							templateText: ".csv",
							downloadTemplateCb: () => {},
						},
					]}
 */

import React, { useRef } from 'react'
import Heading from '../heading/Heading'
import styles from './FileUpload.styles'
import Icons from '../icons/Icons'
import { HEADING } from '../heading/constants/constants'
import { VEC_ICON_NAME } from '../icons/constants'

export default function FileUpload({
    uploadedFile,
    templatesForDownload = [],
    title="Upload the excel file",
    onDropCb = () => { },
    allowedFileType = ['.xlsx', '.csv', '.xls'],
    onInputChangeCb = () => { },
    containerBodyCustomStyles = {},
}) {
    const fileInputRef = useRef(null);

    const getDownloadIcon = (templateText) => {
        const category = categorize(templateText);
        switch(category) {
            case 'xls':
                return VEC_ICON_NAME.EXCEL_SHEET_LOGO
            case 'csv':
                return VEC_ICON_NAME.CSV_FILE_LOGO
            case 'xlsx':
                return VEC_ICON_NAME.XLSX_FILE_LOGO
            default:
                return VEC_ICON_NAME.DOWNLOAD_ICON
        }
    }

    const categorize = (text) => {
        if(text.toLowerCase().includes('xlsx')) {
            return 'xlsx'
        }

        if(text.toLowerCase().includes('xls')) {
            return 'xls'
        }

        if(text.toLowerCase().includes('csv')) {
            return 'csv'
        }

        return ''
    }

    return (
        <>
            <div style={styles.container} onDrop={onDropCb} onDragOver={(e) => e.preventDefault()}>
                <div>
                    <Heading type={HEADING.H1}>{title}</Heading>
                </div>

                <div style={styles.uploadContainer}>

                    <div style={styles.uploadHeader}>
                    { templatesForDownload.length !== 0 &&
                        <>
                            <span style={styles.headerText}>Download our easy to use template to quickly get started </span>

                            <div style={styles.templatesContainer}>
                                {
                                    templatesForDownload.map((template, index) => {
                                        return <div key={index} onClick={template?.downloadTemplateCb}>
                                            <Icons style={styles.downloadIcon} familyName='vec' iconName={getDownloadIcon(template?.templateText)} />
                                            <span style={styles.downloadTemplate}>{template?.templateText}</span>
                                        </div>
                                    })
                                }
                            </div>
                    
                        </>
                    
                    }

                    </div>


                    <div style={{...styles.uploadContainerBody, ...containerBodyCustomStyles}} onClick={() => document.querySelector('input[type=file]').click()}>

                        <div>
                            <Icons familyName='vec' iconName={VEC_ICON_NAME.DRAG_AND_DROP_FILE_ICON} />
                            <div>
                                <p style={styles.bodyContent}>Drag & drop a file or click here <br /> to browse your local computer</p>
                                <span style={styles.supportedFormat}>Supported formats: {allowedFileType.join(", ")}</span>
                            </div>
                        </div>

                        <div >
                            <input type="file" accept={allowedFileType.join(", ")} style={styles.fileInput} onChange={onInputChangeCb} onClick={() => fileInputRef.current.value = null} ref={fileInputRef} />
                            {uploadedFile && <p style={styles.fileName}>Selected file: {uploadedFile.name}</p>}
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}